import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { NormalizedUIField } from '../../../store/config.models';

const SUFFIX_IMG_SIZE = 24;

@Component({
    selector: 'app-button-element',
    templateUrl: './button-element.component.html',
    styleUrls: ['./button-element.component.scss'],
})
export class ButtonElementComponent {
    @Input() field: NormalizedUIField;
    @Input() isReadOnly = false;

    suffixImgSize = SUFFIX_IMG_SIZE;
    constructor(private store: Store, private translate: TranslateService) {}

    get isVisible(): boolean {
        return this.field?.visible !== false;
    }

    /**
     * Handles button click actions by dispatching any configured events
     */
    onButtonAction(event: Event): void {
        if (this.isReadOnly || this.field.disabled) {
            return;
        }

        if (this.field.events?.onClick) {
            this.field.events.onClick(event).forEach((action) => this.store.dispatch(action));
        }
    }
}
